import { CombinedError } from '@urql/core';
import { showErrorMessage } from 'components/Helpers/Toasts';
import { getUserFriendlyErrors } from 'connectors/lib/friendlyErrorMessageParser';
import { logException } from 'helpers/errors/logException';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useEffect } from 'react';

export const useQueryError = (error: CombinedError | undefined, suppressError = false): void => {
    const t = useTypedTranslationFunction();

    useEffect(() => {
        if (error === undefined || suppressError) {
            return;
        }

        if (error.message === 'Token is not valid') {
            showErrorMessage(t('You were automatically logged out after inactivity.'));

            return;
        }

        const parsedErrors = getUserFriendlyErrors(error, t);

        logException(error);

        if (parsedErrors.applicationError === undefined) {
            return;
        }

        showErrorMessage(parsedErrors.applicationError.message);
    }, [error, suppressError, t]);
};
